import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { GoogleWebSignIn } from "@/components/GoogleWebSignIn";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const go = (u) => {
    toast.success(`Welcome back, ${u.name}`);
    if (u.role === "candidate") nav("/app/candidate");
    else if (u.role === "agency") nav("/app/agency");
    else nav("/admin");
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      go(await login(email, password));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex brand-gradient-navy relative overflow-hidden flex-col justify-between p-12">
        <div className="absolute inset-0 brand-dotgrid opacity-40" />
        <Link to="/" className="relative"><Logo variant="light" showTagline /></Link>
        <div className="relative">
          <h2 className="font-display text-4xl font-extrabold text-white leading-tight">One platform. <br />One source of truth.</h2>
          <p className="text-slate-300 mt-4 max-w-md">From registration to deployment — manage the entire global recruitment lifecycle in one connected system.</p>
        </div>
        <div className="relative text-xs text-slate-400">© {new Date().getFullYear()} Emira Manpower &amp; Training Solutions</div>
      </div>

      <div className="flex items-center justify-center p-6 bg-background">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Link to="/"><Logo variant="image" /></Link></div>
          <h1 className="font-display text-3xl font-bold text-[#0A192F]">Sign in</h1>
          <p className="text-slate-500 mt-1">Access your Emira workspace.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div><Label>Email</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
            <div><Label>Password</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#0088FF] hover:bg-[#0070E0] h-11">
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>

          <GoogleWebSignIn onSignedIn={go} />

          <p className="text-sm text-slate-500 mt-5">
            New here? <Link to="/register" className="text-[#0088FF] font-medium">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
